import { render, staticRenderFns } from "./modal-edit-stage.vue?vue&type=template&id=22f28900&"
import script from "./modal-edit-stage.vue?vue&type=script&lang=js&"
export * from "./modal-edit-stage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports